import React from 'react';
import validate from 'validate.js';
import { get } from 'lodash';
import update from 'immutability-helper';
import { FormattedMessage } from 'react-intl';

const validateAttendeePriceForm = (values) => {
  const {
    number_guests,
    tiers
  } = values;

  const constraints = {
    presence: {
      allowEmpty: false,
      message: (<FormattedMessage id="hosting.validate_attendee_price_form.number_of_guest_empty_message" defaultMessage="Enter a number" />)
    },
    numericality: {
      onlyInteger: true,
      greaterThan: 1,
      notGreaterThan: (<FormattedMessage id="hosting.validate_attendee_price_form.number_of_guest_minimum_message" defaultMessage="Enter a number greater than 1"/>)
    }
  };

  const minInputConstraints = update(constraints, {
    numericality: { $merge: {
      lessThan: parseInt(number_guests, 10),
      notLessThan: (<FormattedMessage id="hosting.validate_attendee_price_form.number_of_guest_maximum_message" defaultMessage="Enter a number less than {count}" values={{ count: parseInt(number_guests, 10) }} />)
    } }
  });

  const valueInputConstraints = update(constraints, {
    presence: { $merge: {
      message: (<FormattedMessage id="hosting.validate_attendee_price_form.charge_empty_message" defaultMessage="Enter a charge" />)
    } },
    numericality: { $merge: {
      greaterThan: 0,
      notGreaterThan: (<FormattedMessage id="hosting.validate_attendee_price_form.charge_minimum_message" defaultMessage="Enter a charge greater than 0"/>)
    } }
  });

  return {
    number_guests: validate.single(number_guests, constraints),
    tiers: tiers.map((tier) => {
      return {
        min: validate.single(get(tier, 'min', null), minInputConstraints),
        value: validate.single(get(tier, 'value', null), valueInputConstraints)
      };
    })
  };
};

export default validateAttendeePriceForm;
